module.exports = __webpack_public_path__ + "img/360.331afdd4.png";